import React from 'react';
import './FloatingElement.css';
import { TYPE_META } from '../Score/storyline';

export default function FloatingElement({ event }) {
  const meta = TYPE_META[event.type] || TYPE_META.tariff;

  return (
    <div className={`floating-element floating-element--${meta.className}`}>
      <div className="floating-element-kicker">{meta.kicker}</div>
      {event.img ? (
        <div
          className="floating-element-image"
          style={{ backgroundImage: `url(${event.img})` }}
        />
      ) : (
        <div className="floating-element-emoji">{event.emoji}</div>
      )}
      <div className="floating-element-headline">{event.action}</div>
    </div>
  );
}
